var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoPhotos = function SvgNoPhotos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 116,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80.81 45.76c-8.504 0-17.16-.345-25.256-2.6-7.944-2.205-15.238-6.482-21.74-11.43-4.257-3.22-8.127-5.78-13.654-5.393a25.24 25.24 0 0 0-14.75 5.76c-7.03 6.156-5.974 17.554-3.16 25.55 4.226 12.058 17.087 20.45 28.018 25.895 12.628 6.308 26.505 9.966 40.413 12.079 12.19 1.849 27.856 3.2 38.421-4.765 9.702-7.314 12.364-24.016 9.987-35.292A13.9 13.9 0 0 0 114.1 47.1c-6.816-4.977-16.985-1.655-24.645-1.483-2.845.061-5.74.122-8.646.142M60.004 115.38c20.597 0 37.294-1.041 37.294-2.326s-16.697-2.326-37.294-2.326-37.294 1.041-37.294 2.326 16.697 2.326 37.294 2.326"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    d: "M106.542 14.075a.996.996 0 1 0 0-1.992.996.996 0 0 0 0 1.992M40.316 5.734a.996.996 0 1 0 0-1.99.996.996 0 0 0 0 1.99M52.354 100.528a.996.996 0 1 0 0-1.992.996.996 0 0 0 0 1.992"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M78.93 1v4.368M76.745 3.184h4.369M7.756 19.388v4.369M5.562 21.572h4.379M11.047 80.25v4.379M8.853 82.435h4.379M101.31 35.459v4.368M99.126 37.644h4.369"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    d: "m70.863 9.973-50.99 6.696a6.036 6.036 0 0 0-5.2 6.77l7.773 59.188a6.035 6.035 0 0 0 6.77 5.198l50.99-6.696a6.036 6.036 0 0 0 5.2-6.77l-7.773-59.188a6.036 6.036 0 0 0-6.77-5.198"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M85.716 18.656H34.21a6.045 6.045 0 0 0-6.044 6.045v59.786a6.045 6.045 0 0 0 6.044 6.044h51.506a6.045 6.045 0 0 0 6.045-6.044V24.7a6.045 6.045 0 0 0-6.045-6.045"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m35.856 65.957 10.3-16.793a1.34 1.34 0 0 1 2.48 0l5.84 9.519a1.33 1.33 0 0 0 2.47 0l9.996-16.254a1.33 1.33 0 0 1 2.469 0l14.67 23.904z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M56.398 46.909a3.24 3.24 0 1 0 0-6.482 3.24 3.24 0 0 0 0 6.482"
  })));
};
export default SvgNoPhotos;